import { render, staticRenderFns } from "./IconVolumeHigh.vue?vue&type=template&id=47dac46c&scoped=true"
import script from "./IconVolumeHigh.vue?vue&type=script&lang=ts"
export * from "./IconVolumeHigh.vue?vue&type=script&lang=ts"
import style0 from "./IconVolumeHigh.vue?vue&type=style&index=0&id=47dac46c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dac46c",
  null
  
)

export default component.exports